export const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 2,
  notation: "compact",
});

export const numberFormatter = new Intl.NumberFormat("en-US", {
  style: "decimal",
  maximumFractionDigits: 2,
  notation: "compact",
});

export const numberFormatterFull = new Intl.NumberFormat("en-US", {
  style: "decimal",
  maximumFractionDigits: 0,
});

export const stripQueryParams = (rawUrl: string, params: string[] = []) => {
  if (!rawUrl || params.length == 0) return rawUrl;
  const pattern = new RegExp(`([?&])(${params.join("|")})=[^&]*(&|$)`, "g");
  let cleaned = rawUrl.replace(pattern, (match, sep, key, end) => {
    // If it's the first param ("?param=...") and there are more params, keep '?'
    if (sep === "?" && end === "&") return "?";
    // If it's middle param ("&param=...&"), collapse to single '&'
    if (sep === "&" && end === "&") return "&";
    // Otherwise remove entirely
    return "";
  });

  cleaned = cleaned.replace(/[?&]$/, "");
  return cleaned;
};

export const copyToClipboard = (plain: BlobPart, html: BlobPart) => {
  if (navigator.clipboard && (window as any).ClipboardItem) {
    const blobPlain = new Blob([plain], { type: "text/plain" });
    const blobHtml = new Blob([html], { type: "text/html" });
    const data = [
      new ClipboardItem({
        ["text/plain"]: blobPlain,
        ["text/html"]: blobHtml,
      }),
    ];
    void navigator.clipboard.write(data);
    return;
  }
};
